import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import { Nav } from "react-bootstrap";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import breakpoints from "../../shared/constants";

const StyledMenuItem = styled(Nav.Item)`
  font-size: 0.75rem;
  text-align: center;
  z-index: 1;

  @media (min-width: ${breakpoints.DESKTOP}) {
    font-size: 0.9rem;
  } ;
`;

const Wrapper = styled.div`
  @media (max-width: ${breakpoints.DESKTOP}) {
    position: relative;
    overflow: none;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &nav {
      flex-wrap: nowrap;
    }
  }
`;

const StyledNavLink = styled(Nav.Link)`
  text-decoration: none !important;
  transition: color 0.2s ease-in-out !important;
  display: flex;
  align-items: center;
  color: inherit;

  svg {
    color: inherit;
  }

  &:focus,
  &:hover {
    border: 0 !important;
    color: grey;
  }
`;

function LocaleLinks() {
  const { navigationStore } = useStores();
  const { countryCodeNavigation } = navigationStore;

  if (isEmpty(countryCodeNavigation)) {
    return null;
  }

  return (
    <Wrapper id="locale-links-top-navigation">
      <Nav>
        {countryCodeNavigation.map((page, index) => {
          const href = page.path ? `/${page.path}` : page.externalPath;

          return (
            <StyledMenuItem key={`${href}-${page?.title}`} className="d-flex">
              <StyledNavLink
                as={page.as}
                eventKey={`${page.path}-${index}`}
                href={href}
                passHref
              >
                {page.title}
              </StyledNavLink>
            </StyledMenuItem>
          );
        })}
      </Nav>
    </Wrapper>
  );
}

export default observer(LocaleLinks);
